// Tracking integration for SPA: GTM, Meta Pixel, TikTok Pixel

const GTM_ID = process.env.REACT_APP_GTM_ID || process.env.SEO_GTM_ID || 'GTM-P45R8V7X';
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || process.env.SEO_FB_PIXEL_ID || '1596401514659044';
const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || process.env.SEO_TIKTOK_PIXEL_ID || 'D3F7DSRC77U2R2QSP8J0';

let trackingInitialized = false;

export function initTracking() {
  if (trackingInitialized || typeof window === 'undefined') return;
  trackingInitialized = true;

  // Initialize Google Tag Manager (GTM)
  if (GTM_ID) {
    window.dataLayer = window.dataLayer || [];
    // Push initial gtm start event; GTM script will read it
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(gtmScript);
  }

  // Initialize Meta Pixel (without firing initial PageView here to avoid duplicates)
  if (META_PIXEL_ID && typeof window !== 'undefined') {
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL_ID);
      // Do not call PageView here; we will call it on route changes
    }
  }

  // Initialize TikTok Pixel (without firing initial page here to avoid duplicates)
  if (TIKTOK_PIXEL_ID && typeof window !== 'undefined') {
    const w = window;
    if (!w.ttq) {
      (function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = (w[t] = w[t] || []);
        ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'getOptions', 'setOptions'];
        ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat([].slice.call(arguments, 0)));
          };
        };
        for (var i = 0; i < ttq.methods.length; i++) {
          ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        ttq.instance = function (t) {
          ttq._i = ttq._i || {};
          ttq._i[t] = ttq._i[t] || [];
          return ttq._i[t];
        };
        // Define ttq.load as in official snippet
        ttq.load = function (pixelId) {
          var n = 'https://analytics.tiktok.com/i18n/pixel/events.js';
          ttq._t = +new Date();
          var a = d.createElement('script');
          a.type = 'text/javascript';
          a.async = true;
          a.src = n;
          var s = d.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(a, s);
          ttq._loadOptions = pixelId;
        };
      })(w, document, 'ttq');
      w.ttq.load(TIKTOK_PIXEL_ID);
      // Do not call page() here; we will call it on route changes
    }
  }
}

export function trackSPAView(url = window.location.href, path = window.location.pathname) {
  if (typeof window === 'undefined') return;
  try {
    // GTM page_view event
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_location: url,
        page_path: path,
      });
    }
    // Meta Pixel PageView
    if (window.fbq && META_PIXEL_ID) {
      window.fbq('track', 'PageView');
    }
    // TikTok page
    if (window.ttq && TIKTOK_PIXEL_ID) {
      window.ttq.page();
    }
  } catch (err) {
    // Silently ignore tracking errors
  }
}